import type { JSX } from 'react'
import type { IButtonProps } from '../Button'

import { IconNames } from 'atoms/Icon'
import { COLOR, INDENTS } from 'vars/index'
import { Button } from '../Button'
import {
  ButtonBordersWidth,
  ButtonColors,
  ButtonCorners,
  ButtonFluid,
  ButtonFonts,
  ButtonIconSizes,
  IconPositions,
} from '../Button.h'

export interface IInlineBackwardArrowWithTitleProps extends IButtonProps {}

export const InlineBackwardArrowWithTitle = ({
  title = '',
  icon = IconNames.angleLeft,
  iconPosition = IconPositions.Left,
  iconSize = ButtonIconSizes.medium,
  corners = ButtonCorners.CORNERS_10,
  colorDefault = ButtonColors.COLOR_MAIN_DEFAULT,
  colorHovered = ButtonColors.SURFACE_LIGHT_2,
  colorPressed = ButtonColors.COLOR_MAIN_PRESSED,
  colorDisabled = ButtonColors.COLOR_DISABLED,
  backgroundColorDefault = COLOR.TRANSPARENT,
  backgroundColorDisabled = COLOR.TRANSPARENT,
  borderWidth = ButtonBordersWidth.BORDER_0,
  paddings = [INDENTS.INDENT_40, INDENTS.INDENT_60],
  font = ButtonFonts.Button1,
  fluid = ButtonFluid.Both,
  ...rest
}: IInlineBackwardArrowWithTitleProps): JSX.Element => (
  <Button
    title={title}
    icon={icon}
    iconPosition={iconPosition}
    iconSize={iconSize}
    corners={corners}
    colorDefault={colorDefault}
    colorHovered={colorHovered}
    colorPressed={colorPressed}
    colorDisabled={colorDisabled}
    backgroundColorDefault={backgroundColorDefault}
    backgroundColorDisabled={backgroundColorDisabled}
    borderWidth={borderWidth}
    paddings={paddings}
    font={font}
    fluid={fluid}
    {...rest}
  />
)
